import { useParams } from 'react-router-dom';
import CreateToolPage from '../components/ToolsSection/CreateToolPage';

const EditTool = () => {
  const { id } = useParams();

  return <CreateToolPage toolId={id} />;
};

export default EditTool;
